import { AxiosResponse } from 'axios';
import { axiosInstance } from '../App';
import { SECURED_API_BASE } from './apiConfig';
import { AsyncExportJobDTO } from '../dto/AsyncExportDTO';

const BASE = `${SECURED_API_BASE}/async-exports`;

/** Estado y avance de un export en segundo plano (lo arranca el endpoint de cada reporte). */
export function getAsyncExportStatus(jobId: string): Promise<AsyncExportJobDTO> {
    return axiosInstance.get(`${BASE}/${encodeURIComponent(jobId)}`).then(r => r.data);
}

/** Descarga el archivo listo. Cada export se descarga una vez: después el backend lo borra. */
export function downloadAsyncExport(jobId: string): Promise<AxiosResponse<Blob>> {
    return axiosInstance.get(`${BASE}/${encodeURIComponent(jobId)}/file`, { responseType: 'blob' });
}
